import { useState } from "react";
import "./App.css";
import Clothes from "./Clothes";
import { data } from "./data";
import Buttons from "./Buttons";


function Home( {addFunction} ){
    const [clothes, setClothes] = useState(data); 
    
    const chosenClothes = (searchTerm) => {
      if (searchTerm === 'all') {
          setClothes(data);
          } else {
      const newClothes = data.filter(element => element.searchTerm === searchTerm);
      setClothes(newClothes);
          }
    }
      return(
        <div>
        <div className="cont">
          <h2 className="back">Free Standart Shipping</h2>
        </div>
          <Buttons filteredClothes={chosenClothes}/>
          <Clothes anyWordClothes={clothes} addFunction={addFunction}/>
        </div>
      )
    }
    export default Home;
